module.exports = __webpack_public_path__ + "media/stylesheets/images/lectures/review_sample_image2-9fd04d57d98d78a495e5a54c602af695.png";